import { DismissSwipeArgs } from "./DismissSwipeArgs";

export const DISMISS_SWIPE_DEFAULT_ARGS: DismissSwipeArgs = {
  threshold: 32,
  onDismiss: () => undefined
};

/**
 * Css variable name used by DismissSwipe to indicate drag position on the left
 */
export const DISMISS_SWIPE_VAR_DRAG_LEFT = "--dismiss-swipe-drag-left";

/**
 * Css variable name used by DismissSwipe to indicate drag position on the right
 */
export const DISMISS_SWIPE_VAR_DRAG_RIGHT = "--dismiss-swipe-drag-right";
